import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import { useOrganizationContext } from '../../context/OrganizationProvider/OrganizationProvider';
import { useSocketStore } from '../../store/useSocketStore';
import { useAuthContext } from '../../context';
import { queryKeys } from '../../queryKeys';

export function useOrganizationUsersSocket() {
  const { socket } = useSocketStore();
  const queryClient = useQueryClient();
  const { refetchCurrentUser } = useAuthContext();
  const { clearOrganization, currentOrganization } = useOrganizationContext();

  React.useEffect(() => {
    if (!socket) return;

    const handleInvitationResponded = () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.users.fetchUsers._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.trainers.fetchOrganizationTrainers._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.trainers.fetchInfiniteOrganizationTrainers._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.organizationClients.fetchOrganizationClients._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey:
          queryKeys.organizationClients.fetchInfiniteOrganizationClients._def,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.organizationMembers.fetchOrganizationMembers._def,
      });
    };

    const handleOrganizationDisconnected = async ({
      organizationId,
    }: {
      organizationId: string;
    }) => {
      await refetchCurrentUser();
      if (currentOrganization?.id === organizationId) {
        clearOrganization();
      }
      queryClient.invalidateQueries({
        exact: false,
        queryKey:
          queryKeys.organizations.fetchInfiniteSwitcherOrganizations._def,
      });
    };

    socket.on('user:invitation-responded', handleInvitationResponded);
    socket.on('organization:disconnected', handleOrganizationDisconnected);

    return () => {
      socket.off('user:invitation-responded', handleInvitationResponded);
      socket.off('organization:disconnected', handleOrganizationDisconnected);
    };
  }, [
    socket,
    queryClient,
    refetchCurrentUser,
    clearOrganization,
    currentOrganization,
  ]);
}
